import { InjectionToken } from '@angular/core';

export const ADMIN_PORTAL_URL = new InjectionToken<string>('ADMIN_PORTAL_URL');
